var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"cly-vue-back-link",on:{"click":_vm.back}},[_c('span',{staticClass:"text-medium bu-is-capitalized"},[_c('i',{staticClass:"fas fa-arrow-left bu-pr-3"}),_vm._v(_vm._s(_vm.innerTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }